import React from "react";
import CanvasJSReact from "./canvasjs.react"
var CanvasJS = CanvasJSReact.CanvasJS;
var CanvasJSChart = CanvasJSReact.CanvasJSChart;
var Component = React.Component;

class PieChart extends Component {	


	render() {

		const options = {
			animationEnabled: true,

			exportEnabled: true,
			theme: this.props.theme, // "light1", "dark1", "dark2"
			title:{
				text: this.props.label
			},
			data: [{
				type: "pie",
				indexLabel: "{label}: {y}%",		
				startAngle: -90,

				showInLegend: false,
				//legendText: "{label}",
				toolTipContent: "{label}: <strong>{count} Items</strong>",
				//indexLabelPlacement: "inside",

				dataPoints: this.props.data

			}]
		}
		
		return (
		<div style={{fontSize:5}}>
			<CanvasJSChart options = {options} 
				/* onRef={ref => this.chart = ref} */
			/>
			{/*You can get reference to the chart instance as shown above using onRef. This allows you to access all chart properties and methods*/}
		</div>
		);
	}
}





class ColChart extends Component {	


	/*	constructor(props) {
	
		
			super(props);
			this.state = {
				dataPoints: this.props.data,
				label:this.props.label
				
		
		
			};
		
		
		  }
	*/
	
	
		render() {
	
			const options = {
				exportEnabled: true,
				theme: "light1", // "light1", "dark1", "dark2"

				title:{

					text: this.props.label,

				},
				data: [{
					type: "column",

					dataPoints: this.props.data
				}]
			}
			
			return (
			<div>
				<CanvasJSChart options = {options} 
					/* onRef={ref => this.chart = ref} */
				/>
				{/*You can get reference to the chart instance as shown above using onRef. This allows you to access all chart properties and methods*/}
			</div>
			);
		}
	}





	class DountChart extends Component {	

		
		render() {
			const options = {
				animationEnabled: true,

				subtitles: [{
					text: this.props.subtitle,
					verticalAlign: "center",
					fontSize: 24,
					dockInsidePlotArea: true
				}],
				data: [{
					type: "doughnut",
					showInLegend: false,
					indexLabel: "{label}: {y}",
					yValueFormatString: "#,###'%'",
					dataPoints: this.props.data
				}]
			}
			return (
			<div >
				<CanvasJSChart options = {options}
					/* onRef={ref => this.chart = ref} */
				/>
				{/*You can get reference to the chart instance as shown above using onRef. This allows you to access all chart properties and methods*/}
			</div>
			);
		}
	}
	



 
export {PieChart ,ColChart , DountChart }